import script from "./SpinnerPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./SpinnerPopup.vue?vue&type=script&setup=true&lang=ts"

import "./SpinnerPopup.vue?vue&type=style&index=0&id=08043799&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08043799"]])

export default __exports__